// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import PropTypes from "prop-types";

import { isWhatsappService } from "../../domain/insurancePlan/utils";
import { ServiceCardIntercom } from "./ServiceCardIntercom";
import { ServiceCardWhatsapp } from "./ServiceCardWhatsapp";

export const ServiceCard = ({ insurancePlan, parent }) =>
  isWhatsappService(insurancePlan.identifierType) ? (
    <ServiceCardWhatsapp parent={parent} insurancePlan={insurancePlan} />
  ) : (
    <ServiceCardIntercom parent={parent} insurancePlan={insurancePlan} />
  );

ServiceCard.propTypes = {
  insurancePlan: PropTypes.object,
  parent: PropTypes.oneOf(["home", "services"]),
};
